export default [
    {
        path: "/about",
        component: () => import("../views/about/about"),
        // meta: { title: global.productName }
    },
    {
        path: "/news/ratio",
        component: () => import("../views/news/ratio"),
        // meta: { title: global.productName }
    },
    {
        path: "/news/price",
        component: () => import("../views/news/price"),
        // meta: { title: global.productName }
    },
    {
        path: "/news/price_wz",
        component: () => import("../views/news/price_wz"),
        // meta: { title: global.productName }
    }
];
